// extracted by mini-css-extract-plugin
export default {"companyContainer":"NQ-z","companyImage":"OQ-z","container":"PQ-z","heading":"QQ-z","darkText":"RQ-z","smallHeading":"SQ-z","darkBackground":"TQ-z","whiteBackground":"UQ-z"};